module.exports = __webpack_public_path__ + "static/bot-f9308464d1a02f0e3127b58754b0dc37.svg";